import { useSelector } from 'react-redux';

import { useUserExamUpdate } from '../utils/updateUserExam';
import { defaultFlashcards, defaultVignettes } from '../utils/examUtils';
import type { RootState } from '../store/store';
import type { UserExam } from '../types/User';

/**
 * Makes `exam` the user's active exam — the write both exam pickers issue
 * (the page header's Exam menu and the lecture list's exam target). For a
 * custom preclinical exam the server keeps the preclinical primary and marks
 * the chosen exam active; the first activation also seeds the selected-count
 * defaults the way the header always has. `isActivating` lets callers refuse
 * a second click while the first round-trip is still in flight.
 */
export const useActivateExam = () => {
  const currentUser = useSelector((state: RootState) => state.user.profile);

  const { updateExam, isUpdating } = useUserExamUpdate(undefined, {
    showSuccessMessage: false,
  });

  const activateExam = async (selectedExam: UserExam) => {
    if (!currentUser) return;

    await updateExam({
      userId: currentUser.id,
      examId: selectedExam.id,
      primary: true,
      ...(selectedExam.selectedFlashcardCount &&
      selectedExam.selectedVignetteCount
        ? {}
        : {
            selectedFlashcardCount:
              selectedExam.selectedFlashcardCount ??
              defaultFlashcards(selectedExam),
            selectedVignetteCount:
              selectedExam.selectedVignetteCount ??
              defaultVignettes(selectedExam),
          }),
    });
  };

  return { activateExam, isActivating: isUpdating };
};
